module.exports = __webpack_public_path__ + "static/media/Integrations.3625692d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Integrations.png
// module id = 567
// module chunks = 1